module.exports = __webpack_public_path__ + "static/media/visa.b9ff62ba.svg";